// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__3mjpx","Title":"About_Title__1yPUB","UnderName":"About_UnderName__3RhAz","Name":"About_Name__3hlLI","Body":"About_Body__1vnyu"};